


import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const API_BASE = "https://api.mahal.qa";

const MahalSponsoredCarousel = () => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [pause, setPause] = useState(false);
  const [products, setProducts] = useState([]);
  const [timers, setTimers] = useState({});
  const { t, i18n } = useTranslation();
const isArabic = i18n.language === "ar";

const localizeNumber = (value) => {
  return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
    Number(value || 0)
  );
};

const localizeCurrency = (currency, price) => {
  return isArabic
    ? `${localizeNumber(price)} ${t("qar")}`
    : `${currency} ${localizeNumber(price)}`;
};

  /* ================= FETCH FROM BACKEND ================= */
  useEffect(() => {
    fetch(`${API_BASE}/api/sponsored`)
      .then((res) => res.json())
      .then((data) => {
        const mapped = (data || []).map((item) => ({
          id: item.id,
          img: item.image,
          currency: item.currency,
          price: item.price,
          tag: item.tag,
          tag_ar: item.tag_ar || item.tag,
          supplier: item.supplier_name || "Verified Supplier",
          supplier_ar: item.supplier_name_ar || item.supplier_ar || item.supplier_name || "Verified Supplier",
          offerEndsIn: item.ends_in || 0,
        }));

        setProducts(mapped);

        // init timers
        const t = {};
        mapped.forEach((p) => {
          t[p.id] = p.offerEndsIn;
        });
        setTimers(t);
      })
      .catch((err) => console.error("ERROR:", err));
  }, [i18n.language]);

  /* ================= AUTO SCROLL ================= */
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let pos = 0;
    const interval = setInterval(() => {
      if (pause) return;

      pos += 1;
      el.scrollLeft = pos;

      if (pos >= el.scrollWidth - el.clientWidth) {
        pos = 0;
        el.scrollLeft = 0;
      }
    }, 25);

    return () => clearInterval(interval);
  }, [pause, products]);

  /* ================= COUNTDOWN ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      setTimers((prev) => {
        const updated = {};
        products.forEach((item) => {
          const current = prev[item.id] ?? item.offerEndsIn;
          updated[item.id] = current > 0 ? current - 1 : 0;
        });
        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [products]);

const formatTime = (s) => {
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;

  return isArabic
    ? `${localizeNumber(h)} ${t("hour")} ${localizeNumber(m)} ${t("minute")} ${localizeNumber(sec)} ${t("second")}`
    : `${h}h ${m}m ${sec}s`;
};

  return (
    <div className="container mt-5" dir={isArabic ? "rtl" : "ltr"}>

      {/* HEADER */}
      <h3 className="mm-sponsored-heading">
        {t("supplier_spotlight")}
      </h3>

      <p className="mm-sponsored-sub">
        {t("trusted_suppliers_limited_offers")}
      </p>

      {/* CAROUSEL */}
      <div
        className="mm-sponsored-row"
        ref={scrollRef}
        onMouseEnter={() => setPause(true)}
        onMouseLeave={() => setPause(false)}
      >
        {products.map((item) => (
          <div
            className="mm-sponsored-card"
            key={item.id}
            onClick={() =>
              navigate(`/shopdetails/${item.id}`)
            }
          >
            {/* OFFER BADGE */}
            <span className="mm-ribbon">{isArabic ? item.tag_ar : item.tag}</span>

            {/* TIMER */}
            <span className="mm-countdown">
              {t("ends_in_upper")} · {formatTime(
                timers[item.id] ?? item.offerEndsIn
              )}
            </span>

            {/* IMAGE */}
            <div className="mm-sponsored-img">
              <img src={item.img} alt={isArabic ? item.tag_ar : item.tag} />
            </div>

            {/* CONTENT */}
            <div className="mm-sponsored-content">
              <strong>{localizeCurrency(item.currency, item.price)}</strong>

              <p className="mm-supplier">
                {isArabic ? item.supplier_ar : item.supplier}   
              </p>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/shopdetails/${item.id}`);
                }}
              >
                {t("view_product")}
              </button>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default MahalSponsoredCarousel;